export const siteMeta = {
  name: "爆料91",
  slogan: "吃瓜现场之外的讨论，都在这",
  intro:
    "爆料91是一个把「围观现场之外的声音」汇集起来的内容社区。我们不追着事件本身跑，而是把散落在评论区的热门讨论、网友观点与舆论反应整理成可读的话题卡片，让每一次吃瓜都能看到不同立场的表达。",
  email: "talk@baoliao91.example.com",
  workingHours: "每天 09:00 - 23:00 更新热门讨论",
  since: "2021",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "热议话题", to: "/topics" },
  { label: "投稿爆料", to: "/submit" },
  { label: "关于我们", to: "/about" },
];

export const categories = [
  { id: "all", name: "全部话题", icon: "ri-fire-line", desc: "所有正在被讨论的话题" },
  { id: "variety", name: "综艺现场", icon: "ri-movie-2-line", desc: "赛制、嘉宾与现场反应的讨论" },
  { id: "drama", name: "影视热议", icon: "ri-clapperboard-line", desc: "剧集口碑、结局与选角的争论" },
  { id: "music", name: "音乐现场", icon: "ri-music-2-line", desc: "演出、音乐节与乐迷反馈" },
  { id: "creator", name: "内容创作者", icon: "ri-video-chat-line", desc: "博主、主播与创作者动态" },
  { id: "backstage", name: "幕后花絮", icon: "ri-camera-lens-line", desc: "路透、服化道与制作细节" },
  { id: "industry", name: "行业观察", icon: "ri-line-chart-line", desc: "制作、平台与从业者动向" },
];

export const hotTicker = [
  "《披荆斩棘的舞台3》赛制改动评分走高",
  "都市剧《长街灯火》大结局片段被反复讨论",
  "星潮音乐节临时换场，观众现场反应两极",
  "博主「山野食记」停更三个月后回归",
  "某剧组路透流出，服化道成当天讨论焦点",
  "年度剧集口碑榜出炉，评分差距引发讨论",
];

export const siteStats = [
  { value: "3,200+", label: "累计收录热议话题" },
  { value: "18.6万", label: "评论区观点条目" },
  { value: "42.3万", label: "参与讨论的网友" },
  { value: "24小时", label: "热门讨论滚动更新" },
];

export const siteValues = [
  {
    icon: "ri-eye-line",
    title: "只呈现多方观点",
    desc: "每一个话题都尽量保留支持、质疑与中立的三种声音，不做单向定论。",
  },
  {
    icon: "ri-links-line",
    title: "讨论不脱离上下文",
    desc: "把评论区的争论放回事件本身，让围观不至于只剩下情绪。",
  },
  {
    icon: "ri-shield-check-line",
    title: "尊重当事人边界",
    desc: "不公开隐私信息，不对未经证实的指控下定论，留给讨论足够的空间。",
  },
  {
    icon: "ri-refresh-line",
    title: "实时滚动更新",
    desc: "热门讨论随时追加，新出现的观点会在当天内补进对应话题。",
  },
];

export const voices = [
  {
    name: "瓜田里的小刘",
    role: "常驻评论区网友",
    content:
      "以前吃瓜全靠翻评论区，经常翻到一半就断了。爆料91把大家的观点整理成段落，谁在争什么一眼就能看懂。",
  },
  {
    name: "追剧不熬夜",
    role: "影视话题关注者",
    content:
      "《长街灯火》结局那期整理得挺客观，支持和反对的理由都列出来了，看完再去评论居然能接上话。",
  },
  {
    name: "巡演打卡人",
    role: "音乐现场爱好者",
    content:
      "音乐节换场那次，我是靠这里的实时滚动才知道后面怎么处理的，比只刷一条动态清楚太多。",
  },
  {
    name: "半糖不加冰",
    role: "热心投稿网友",
    content:
      "投稿入口挺好用的，我提的线索第二天就出现在话题里了，还标注了来源整理时间。",
  },
];

export const footerColumns = [
  {
    title: "热门板块",
    links: [
      { label: "热议话题", to: "/topics" },
      { label: "综艺现场", to: "/topics?category=variety" },
      { label: "影视热议", to: "/topics?category=drama" },
      { label: "音乐现场", to: "/topics?category=music" },
    ],
  },
  {
    title: "参与方式",
    links: [
      { label: "投稿爆料", to: "/submit" },
      { label: "评论互动指引", to: "/about" },
      { label: "内容原则", to: "/about" },
      { label: "关于我们", to: "/about" },
    ],
  },
];